import React, { Component } from 'react';
/* eslint-disable */
import ReactDOM from 'react-dom';

import axios from 'axios';
import { MY_API_URL } from '../../Apanel/QueryMe';
import Switch from 'react-switch';
import SearchIcon from 'mdi-react/SearchIcon';

import {
	Button,
	ButtonGroup,
	ButtonToolbar,
	Card,
	CardBody,
	Col,
	Badge,
	Table,
	Modal,
} from 'reactstrap';

import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import Alert from '../../../shared/components/Alert';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
const apiurl = MY_API_URL;
const initialstate = {
	keywords: [],
	relatedKeywords: [],
	keyword: '',
	tshowAlert: false,
	showAlert: false,
	alertType: '',
	alertText: '',
	keyId: 0,
	keyName: '',
	oldkeyname: '',
	newkeyname: '',
	noorid: 0,

	addKeyModal: false,
	akeys: 0,
	bkeys: 0,
	tkeys: 0,
	token: localStorage.token,
};
class CountryFlags extends Component {
	constructor(props) {
		super(props);
		// this._handleFocus = this._handleFocus.bind(this);
		// this._handleFocusOut = this._handleFocusOut.bind(this);
	}
	state = { ...initialstate };
	componentDidMount() {
		this.handleGetkeys(localStorage.token);
	}

	handleTkey = (id, keyword, checked) => {
		console.log(checked + 'checked');
		console.log(id + 'id');
		console.log(keyword + 'keyword');
		var keysts = checked == true ? 1 : 0;
		var kstatus = 'Deactivate';
		if (checked) {
			kstatus = 'Activate';
		}
		swal({
			title: kstatus + ' ' + keyword,
			text: 'Are you sure?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then((keyconfirm) => {
			if (keyconfirm) {
				const headers = {
					'Content-Type': 'application/json',
					Authorization: localStorage.token,
				};

				const togkeyurl = apiurl + 'togcountry';
				var postData = {
					keyid: id,
					kstatus: keysts,
				};
				axios
					.post(togkeyurl, postData, {
						headers: headers,
					})
					.then((response) => {
						console.log(response.data.message);

						if (response.data.error) {
							swal(keyword + ' ' + response.data.message, {
								icon: 'warning',
							});
						} else {
							this.handleGetkeys(localStorage.token);
							swal(keyword + ' ' + response.data.message, {
								icon: 'success',
							});
						}
					})
					.catch((error) => {
						console.log('Error is ', error);
						swal('Try Again Later', {
							icon: 'Danger',
						});
					});
			}
		});
	};

	handleGetkeys = (token) => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			token: token,
		};
		const getuurl = apiurl + 'admincountries';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				let akeys = 0;

				let tkeys = 0;
				if (response.data.error) {
					this.setState({
						akeys: akeys,
						bkeys: tkeys - akeys,
						tkeys: tkeys,
						keywords: [...response.data.allkeys],
						relatedKeywords: [...response.data.allkeys],
					});
				} else {
					const allkeys = [...response.data.allkeys];

					allkeys.map((dkey) => {
						akeys = akeys + parseInt(dkey.activated, 10);
						tkeys = tkeys + 1;
					});

					this.setState({
						akeys: akeys,
						bkeys: tkeys - akeys,
						tkeys: tkeys,
						keywords: [...response.data.allkeys],
						relatedKeywords: [...response.data.allkeys],
					});
				}
			})
			.catch((error) => {
				localStorage.clear();
				this.props.history.push('/');
			});
	};

	fuzzy = (source, target) => {
		var hay = source.cname.toLowerCase(),
			i = 0,
			n = -1,
			l;

		if (!target) {
			return;
		}

		target = target.toLowerCase();

		for (; (l = target[i++]); ) {
			if (!~(n = hay.indexOf(l, n + 1))) {
				return false;
			}
		}

		return true;
	};
	handleSearch = (e) => {
		this.setState(
			{
				technologyToSearch: e.target.value,
			},
			() => {
				if (this.state.technologyToSearch === '') {
					this.setState({
						relatedKeywords: [...this.state.keywords],
					});
				} else {
					let relatedKeywords = this.state.keywords.filter((keyword) => {
						return this.fuzzy(keyword, this.state.technologyToSearch);
					});
					this.setState({
						relatedKeywords: [...relatedKeywords],
					});
				}
			},
		);
	};
	render() {
		const { keyword } = this.state;
		return (
			<Col md={12}>
				<Card>
					<CardBody>
						<div className="card__title">
							<h5 className="bold-text">
								Total Countries{' '}
								<Badge color="primary">Total {this.state.tkeys} </Badge>
								{'  '}
								<Badge color="success">Active {this.state.akeys} </Badge>
								{'  '}
								<Badge color="warning">InActive {this.state.bkeys} </Badge>
								{'  '}
							</h5>
						</div>
						<form className="form">
							<div className="form__form-group">
								<div className="form__form-group-field">
									<div className="form__form-group-icon">
										<SearchIcon />
									</div>
									<input
										name="tkey"
										type="text"
										placeholder="Search"
										onChange={(e) => {
											this.handleSearch(e);
										}}
									/>
								</div>
							</div>
						</form>
						{this.state.tshowAlert ? (
							<Alert color={this.state.alertType}>
								<p>{this.state.alertText}</p>
							</Alert>
						) : null}

						<Table responsive hover>
							<thead>
								<tr>
									<th>#</th>
									<th>Country</th>
									<th>Prefix</th>
									<th>Code</th>
									<th>Flag</th>
									<th>Manage</th>
								</tr>
							</thead>
							<tbody>
								{this.state.relatedKeywords &&
									this.state.relatedKeywords.map((hkey, index) => {
										var ksts = false;
										if (hkey.activated === 1) {
											ksts = true;
										}
										var flagname = hkey.ccode;
										flagname = flagname.toLowerCase();
										return (
											<tr key={index}>
												<td>{index + 1}</td>

												<td>
													<strong>{hkey.cname}</strong>
												</td>
												<td>
													<strong>{hkey.prefix}</strong>
												</td>
												<td>
													<strong>{hkey.ccode}</strong>
												</td>
												<td>
													<img
														src={'flags/' + flagname + '.svg'}
														width="75px"
														height="35px"
													/>
												</td>

												<td>
													<Switch
														onChange={this.handleTkey.bind(
															this,
															hkey.id,
															hkey.cname,
														)}
														checked={ksts}
													/>
												</td>
											</tr>
										);
									})}
							</tbody>
						</Table>
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default CountryFlags;
